<template>
  <div style="margin-bottom: 10px">
    <el-cascader
      :options="availableAttachments"
      v-model="valuesOfNodes"
      clearable
      filterable
      placeholder="请选择物品（可搜索）"
      :props="{ expandTrigger: 'hover' }"
    ></el-cascader>
    <span>&nbsp;x&nbsp;</span
    ><el-input v-model="attachmentNumber" class="number-input"></el-input>
    <el-button
      @click="onClickRemoveBtn()"
      style="margin-left: 10px"
      icon="el-icon-delete"
      circle
    ></el-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      valuesOfNodes: this.value.valuesOfNodes,
      attachmentNumber: this.value.number,
    };
  },

  props: {
    availableAttachments: Array,
    value: Object,
  },

  watch: {
    valuesOfNodes() {
      this.$emit("input", this.formattedAttachment);
    },

    /**
     * 修正数目输入框里的值，保证每个字符都是数字
     */
    attachmentNumber() {
      for (let i = 0; i < this.attachmentNumber.length; i++) {
        let n = parseInt(this.attachmentNumber[i]);
        if (isNaN(n)) {
          this.attachmentNumber = this.attachmentNumber.substr(0, i)
          break;
        }
      }

      if (this.attachmentNumber == '') {
        this.attachmentNumber = "1";
      }

      this.$emit("input", this.formattedAttachment);
    },
  },

  computed: {
    /**
     * 用来返回给外部的
     */
    formattedAttachment() {
      return {
        valuesOfNodes: this.valuesOfNodes,
        number: this.attachmentNumber,
      };
    },
  },

  methods: {
    onClickRemoveBtn() {
      // 向父组件抛出事件
      this.$emit("remove");
    },
  },
};
</script>

<style lang="scss" scoped>
.number-input {
  width: 120px;
}
</style>